import { useState } from 'react';
import { useQuery, useAction } from 'wasp/client/operations';
import { getOrganizationMemberships, addOrganizationMember, updateOrganizationMember, removeOrganizationMember } from 'wasp/client/operations';
import { Button } from '../../components/ui/button';

export default function OrganizationMembershipsPage({ organizationId }: { organizationId: string }) {
  const { data: memberships = [], refetch } = useQuery(getOrganizationMemberships, { organizationId });
  const addMember = useAction(addOrganizationMember);
  const updateMember = useAction(updateOrganizationMember);
  const removeMember = useAction(removeOrganizationMember);
  const [newUserId, setNewUserId] = useState('');
  const [newRole, setNewRole] = useState('MEMBER');
  const [newAccessLevel, setNewAccessLevel] = useState('SUBSCRIBER');

  const handleAdd = async () => {
    if (!newUserId) return;
    await addMember({ organizationId, userId: newUserId, role: newRole, accessLevel: newAccessLevel });
    setNewUserId('');
    refetch();
  };

  return (
    <div>
      <h2>Organization Members</h2>
      <div>
        <input value={newUserId} onChange={e => setNewUserId(e.target.value)} placeholder="User ID" />
        <select value={newRole} onChange={e => setNewRole(e.target.value)}>
          <option value="ADMIN">Admin</option>
          <option value="MANAGER">Manager</option>
          <option value="MEMBER">Member</option>
          <option value="SUBSCRIBER">Subscriber</option>
        </select>
        <select value={newAccessLevel} onChange={e => setNewAccessLevel(e.target.value)}>
          <option value="ADMIN">Admin</option>
          <option value="VERIFIED">Verified</option>
          <option value="SUBSCRIBER">Subscriber</option>
        </select>
        <Button onClick={handleAdd}>Add Member</Button>
      </div>
      <ul>
        {memberships.map((m: any) => (
          <li key={m.userId}>
            {m.user?.fullName || m.user?.email || m.userId} - {m.role} - {m.accessLevel}
            <Button onClick={async () => { await removeMember({ organizationId, userId: m.userId }); refetch(); }} size="sm">Remove</Button>
          </li>
        ))}
      </ul>
    </div>
  );
}



